import { render, staticRenderFns } from "./ReportEntranceDistribution.vue?vue&type=template&id=1d2f9c20&scoped=true&"
import script from "./ReportEntranceDistribution.vue?vue&type=script&lang=ts&"
export * from "./ReportEntranceDistribution.vue?vue&type=script&lang=ts&"
import style0 from "./ReportEntranceDistribution.vue?vue&type=style&index=0&id=1d2f9c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f9c20",
  null
  
)

component.options.__file = "ReportEntranceDistribution.vue"
export default component.exports